// extracted by mini-css-extract-plugin
export default {"background":"#f4f5f9","blackBlue":"#42567a","dot":"Dot_dot__2IFBa","dot__category":"Dot_dot__category__2SBJF"};